import { createActionConst } from '../../../utils/action.utils';

const ANNUAL_NAMESPACE = 'ANNUAL';

export const STORE_ANNUAL = createActionConst(ANNUAL_NAMESPACE, 'STORE_ANNUAL');
export const CLEAR_ANNUAL = createActionConst(ANNUAL_NAMESPACE, 'CLEAR_ANNUAL');
